import React, { createContext, useContext, useState, useEffect } from 'react';
import { getUser, getToken, removeToken, removeUser, setUser as persistUser, authAPI } from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUserState] = useState(() => getUser());
  const [token, setTokenState] = useState(() => getToken());

  // Self-heal: if a user is already logged in from *before* the backend was
  // fixed to include `user.id` (previously only `_id` was returned), their
  // cached profile is stale and every owner/assignment check comparing
  // against `user.id` silently fails. Refresh once from /auth/me so this
  // corrects itself without forcing everyone to log out and back in.
  useEffect(() => {
    if (token && user && !user.id) {
      authAPI.me()
        .then((d) => {
          if (d?.user) {
            persistUser(d.user);
            setUserState(d.user);
          }
        })
        .catch(() => {});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const login = (userData, tokenValue) => {
    localStorage.setItem('tse_token', tokenValue);
    localStorage.setItem('tse_user', JSON.stringify(userData));
    setUserState(userData);
    setTokenState(tokenValue);
  };

  const logout = () => {
    removeToken();
    removeUser();
    setUserState(null);
    setTokenState(null);
  };

  return (
    <AuthContext.Provider value={{ user, token, login, logout, isLoggedIn: !!token }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
